// removed by extract-text-webpack-plugin
module.exports = {"statistics":"_3gF1AtV4cqKMw_lwJ9B6iS"};